import { AppBar, Grid, Toolbar, Typography } from "@mui/material";
import React, { useRef } from "react";
import {
    WorkflowLoading,
    WorkflowReviewStore,
} from "../Stores/WorkflowReviewStore";
import { useStore } from "utils/useStore";
import { observer } from "mobx-react";
import { useNavigate } from "react-router";
import NotificationMenuIcon from "components/Notifications/NotificationMenuIcon";
import ProfileMenuIcon from "components/Navigation/ProfileMenuIcon";
import AcxButton from "components/UI/AcxButton";
import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";
import { IconButton } from "@mui/material";
import ChevronLeftSharpIcon from "@mui/icons-material/ChevronLeftSharp";

const WFRAppBar = observer(() => {
    const appBarRef = useRef(null);
    const navigate = useNavigate();
    const store = useStore(WorkflowReviewStore);
    const pageLoading = store.getTaskLoadingV2(WorkflowLoading);

    return (
        <AppBar
            ref={appBarRef}
            sx={{
                backgroundColor: "#ffffff",
                width: "100%",
                position: "relative",
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            elevation={1}
            position="sticky"
        >
            <Toolbar>
                <Grid container direction="row" justifyContent="space-between">
                    <Grid
                        container
                        item
                        justifyContent="flex-start"
                        alignItems="center"
                        xs={6}
                    >
                        <Grid
                            item
                            sx={{ marginRight: (theme) => theme.spacing(0.5) }}
                        >
                            <IconButton
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <ChevronLeftSharpIcon />
                            </IconButton>
                        </Grid>
                        <Grid
                            item
                            sx={{ marginRight: (theme) => theme.spacing(0.5) }}
                        >
                            <Typography fontWeight={700}>
                                Workflow for Evaluation
                            </Typography>
                        </Grid>
                        <Grid item>
                            {pageLoading &&
                            !store.workflowReviewerInfo?.workflowInfo
                                .evaluationQbId ? (
                                <AcxLoadingIndicator
                                    color={"secondary"}
                                    alternate={"PuffLoader"}
                                    size={25}
                                />
                            ) : (
                                <Typography fontWeight={700}>
                                    {`#${store.workflowReviewerInfo?.workflowInfo
                                            .evaluationQbId ?? ""}`}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container item justifyContent="flex-end" xs={6} alignItems="center">
                        <Grid item>
                            <AcxButton
                                sx={{marginRight: "0.5rem"}}
                                fullWidth
                                color="white"
                                onClick={() => {
                                    navigate(
                                        `/evaluation/${store.orgId}/${store.evalId}`,
                                    );
                                }}
                            >
                                View Evaluation
                            </AcxButton>
                        </Grid>
                        <Grid item>
                            <NotificationMenuIcon
                            // drawerOffsetPx={appBarHeight}
                            />
                        </Grid>

                        <Grid item>
                            <ProfileMenuIcon
                                currLocation={"mainApp"}
                                organizationName={
                                    store.authStore.orgStore
                                        .selectedOrganization?.name ?? ""
                                }
                                customRootStyles={{
                                    marginLeft: "0.5rem",
                                    marginRight: "0.25rem",
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
});

export default WFRAppBar;
